import {formatTableData} from 'utils/util';

const GET_ACCOUNT_LIST_START = 'zb/GET_ACCOUNT_LIST_START';
const GET_ACCOUNT_LIST_SUCCESS = 'zb/GET_ACCOUNT_LIST_SUCCESS';
const GET_ACCOUNT_LIST_FAILED = 'zb/GET_ACCOUNT_LIST_FAILED';

let initialState = {
  accountList: [],
  total: 0
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        accountList: formatTableData(action.resp.data && action.resp.data.list || []),
        total: action.resp.data && action.resp.data.total
      };
    default:
      return state;
  }
}

export function getAccountList(data = {}) {
  return {
    types: [GET_ACCOUNT_LIST_START, GET_ACCOUNT_LIST_SUCCESS, GET_ACCOUNT_LIST_FAILED],
    promise: (client) => client.get('bill/flow/accList', {
      params: data,
    })
  };
}
